import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import { getToken } from "../../../../../utils/token";
import instance from "../../../../../axios/instance";
import { NoAccessInfo } from "../../../../../components/NoAccessInfo";

export const consultationsLayoutLoader = async () => {
  const token = getToken();
  const plan = await instance.get("/doctor/billing/plan/active", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return { plan: plan.data };
};

export const ConsultationsLayout = () => {
  const { plan } = useLoaderData();
  const noConsultationAccess = plan.noAccess.includes("/consultations");
  return (
    <div className="py-5 px-5 max-h-[calc(100vh_-_32px)] overflow-y-scroll scrollbar-hide">
      {noConsultationAccess ? (
        <NoAccessInfo
          msg={`Your current plan (${plan.name}) does not include the external Consultation feature`}
        />
      ) : (
        <Outlet />
      )}
    </div>
  );
};
